import { useEffect } from "react";

import { SITE_NAME, SITE_URL } from "./site";

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, name] = selector.match(/\[(?:name|property)="([^"]+)"\]/) ?? [];
    el.setAttribute(selector.includes("property=") ? "property" : "name", name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

/**
 * Gives each route its own title, description and canonical URL. A single-page
 * app otherwise serves one static <title> for every page, which reads as an
 * unfinished template to crawlers and ad reviewers alike.
 */
export default function usePageMeta({ title, description, path }) {
  useEffect(() => {
    const full = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    document.title = full;

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
    }
    setMeta('meta[property="og:title"]', "content", full);
    setMeta('meta[property="og:type"]', "content", "website");

    if (path) {
      const url = `${SITE_URL}${path}`;
      setMeta('meta[property="og:url"]', "content", url);

      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", url);
    }
  }, [title, description, path]);
}
